// import statistics from './statistics-menu'
import adminMenu from './admin-menu'
import clubMenu from './club-menu'
// import { USER } from '../../utils/variables'
// import team from './team-menu'
// const userData = JSON.parse(localStorage.    getItem('userData'))
// console.log('usuario en menu', USER())
// console.log('cargando index')
const menuAdmin = [...adminMenu]
const menuClub = [...clubMenu]
// const menuClub = [...statistics]
// const menuTeam = [...statistics, ...team, ...admin]
// const a = false
// const logger = a ? menuAdmin : menuTeam

// export default [...statistics, ...admin]
export { menuAdmin, menuClub }

// export default [separa]
